import mapActions from './mapActions';

export default mapActions('entity_operations', {
    fetchAll_url: data => `/api/entity_operations/entity/${data.id}`
});
